export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20shopping%20concept%20with%20designer%20handbag%20and%20silk%20scarf%20on%20soft%20blush%20pink%20background%2C%20warm%20golden%20accent%20details%2C%20luxurious%20Italian%20editorial%20photography%2C%20soft%20natural%20window%20light%2C%20airy%20sophisticated%20composition%20with%20fresh%20peony%20flowers%20accent&width=1600&height=700&seq=cta-v2-banner&orientation=landscape"
            alt="Itaobuy Spreadsheet prodotti"
            className="w-full h-[400px] md:h-[500px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/55 to-foreground-900/15"></div>
        </div>

        <div className="text-center mt-12 md:mt-16 max-w-[700px] mx-auto">
          <p className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-900 leading-snug mb-3">
            Trova i migliori prodotti
          </p>
          <p className="text-3xl md:text-4xl lg:text-5xl font-heading italic text-foreground-500 leading-snug mb-3">
            su Itaobuy Spreadsheet
          </p>
          <p className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-snug mb-10">
            in modo semplice
          </p>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-foreground-900 text-white font-medium text-base hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}